import { render, staticRenderFns } from "./returnreject-addremark.vue?vue&type=template&id=733f9cca&"
import script from "./returnreject-addremark.vue?vue&type=script&lang=ts&"
export * from "./returnreject-addremark.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports